import React from 'react'
import PropTypes from 'prop-types'

import { GENRE_FILTER } from '../../../constants/commons'
import TopicHelpers from '../../../classes/TopicHelpers'
import TopicPlanFilterHelpers from '../../../classes/TopicPlanFilterHelpers'

class GenreFilterComponent extends React.Component {
  static propTypes = {
    filters: PropTypes.object.isRequired,
    selectedPlanFilters: PropTypes.object.isRequired,
    setFilters: PropTypes.func.isRequired,
    module: PropTypes.string.isRequired
  }

  constructor (props) {
    super(props)

    this.state = {
      genreFilter: this.props.selectedPlanFilters.genreFilters || []
    }
  }

  componentDidUpdate (previousProps) {
    if (previousProps.selectedPlanFilters !== this.props.selectedPlanFilters) {
      this.setState({ genreFilter: this.props.selectedPlanFilters.genreFilters || []})
    }
  }

  render () {
    return (
      <>
        <ul className="checkList">
          <li><h4>Genre Filters (AND)</h4></li>
          {this.li('Action and Adventure')}
          {this.li('Comedy')}
          {this.li('Crime Drama')}
          {this.li('Documentary')}
          {this.li('Docuseries')}
          {this.li('Drama')}
          {this.li('Game Show')}
          {this.li('Lifestyle')}
          {this.li('News')}
          {/* {this.li('Procedural')} */}
          {this.li('Reality')}
          {this.li('Reality Competition')}
          {this.li('Science Fiction')}
          {this.li('Sitcom')}
          {this.li('Spanish Language')}
          {this.li('Special')}
          {this.li('Sports')}
          {this.li('Talk')}
        </ul>
      </>
    )
  }

  li = (filterText) => {
    const genreFilter = TopicPlanFilterHelpers.genreFilter(filterText)
    const currentValue = this.state.genreFilter.find(f => TopicHelpers.equals(f, genreFilter))
    const value = currentValue ? true : false
    return (
      <li>
        <input
          type="checkbox" id={`${filterText}`}
          checked={value}
          onChange={this.applyGenreFilter.bind(this, filterText)} />
        <span></span>
        <label htmlFor={`${filterText}`}>{filterText}</label>
      </li>
    )
  }

  /** Apply one of the genre and update the table filtering */
  applyGenreFilter = (filter) => {
    let filters = null

    if (filter !== 'None') {
      filters = TopicPlanFilterHelpers.genreFilter(filter)
    }

    this.props.setFilters(filters, GENRE_FILTER, this.props.module)
  }
}

export default GenreFilterComponent